// extracted by mini-css-extract-plugin
module.exports = {"TabsContainer":"TabsPanel_TabsContainer__33lyy","Tab":"TabsPanel_Tab__1ZVPC"};